import type { MfrrMarket } from 'api/mfrr/mfrr.types'
import Datetime from 'utils/datetime/datetime'
import { proxy } from 'valtio'

export type MfrrViewedBidWindow = {
  market: MfrrMarket
  startTime: ISODateTime
  endTime: ISODateTime
}

export type MfrrDateRangeOption = 'today' | 'tomorrow' | 'dayAfterTomorrow' | 'custom'

export type MfrrSelectedPeriod = {
  switchValue: MfrrDateRangeOption
  startTime: ISODateTime
  endTime: ISODateTime
}

type MfrrStore = {
  viewedBidWindow?: MfrrViewedBidWindow
  // Remembered across navigation so leaving and returning to the trading view keeps the
  // previously selected period instead of resetting to the default.
  selectedPeriod: MfrrSelectedPeriod
}

const initialIsoNow = Datetime.getISONow()

const mfrrStore = proxy<MfrrStore>({
  viewedBidWindow: undefined,
  selectedPeriod: {
    switchValue: 'dayAfterTomorrow',
    startTime: Datetime.getStartOfDay(initialIsoNow),
    endTime: Datetime.getEndOfDay(initialIsoNow),
  },
})

export function setMfrrSelectedPeriod(period: MfrrSelectedPeriod): void {
  mfrrStore.selectedPeriod = period
}

export default mfrrStore
